/* Adds a quiet "Reviews verified by Judge.me" link under the review
   summary on product pages (Judge.me renders the widget client-side, so
   watch for it). Links to the store's all-reviews page. */
(function () {
  'use strict';
  function add() {
    var summary = document.querySelector('.jdgm-rev-widg .jdgm-rev-widg__summary-text');
    if (!summary || summary.parentNode.querySelector('.lacaza-reviews-verified')) return;
    var a = document.createElement('a');
    a.className = 'lacaza-reviews-verified';
    a.href = '/pages/reviews';
    a.textContent = 'Reviews verified by Judge.me';
    summary.insertAdjacentElement('afterend', a);
  }
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(add);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', add); else add();
})();
